import { render, staticRenderFns } from "./SettingsTwo.vue?vue&type=template&id=ead81d06&scoped=true&"
import script from "./SettingsTwo.vue?vue&type=script&lang=js&"
export * from "./SettingsTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead81d06",
  null
  
)

export default component.exports